import { type TimeLocaleDefinition, timeFormatLocale } from "d3-time-format";
import timeDefinition from "d3-time-format/locale/de-CH";

// The locale JSON is inferred with array-shaped fields (string[]) rather than
// TimeLocaleDefinition's fixed-length tuples (e.g. a 7-tuple for `days`).
const locale = timeFormatLocale(timeDefinition as TimeLocaleDefinition);

export const timeFormat = locale.format;
